import { useSharedContactValidations, type IContactValidations } from '@gem/modules/validations';

import { phoneNumberAsyncValidation } from '../fields/fields';

export const useContactValidations = (): IContactValidations => {
  return useSharedContactValidations({
    phoneNumberAsyncValidation,
  });
};
